// Debug
const url_debug = 'https://localhost:44364';

export default {

    getUrl() {
        if (window.location.host.includes("localhost"))
            return url_debug

        return window.location.protocol + "//" + window.location.host
    },

    getUrlApi() {

        let url = this.getUrl();
        url += "/api"

        return url

    },

}
